/**
 * Resolve API-returned image/media URLs (often relative) to absolute URLs using the API origin.
 */
export function useGetAbsoluteUrl() {
  const config = useRuntimeConfig();
  const baseURL = config.public.baseURL as string;
  const origin = typeof baseURL === "string" ? new URL(baseURL).origin : "";

  function getAbsoluteUrl(url: string | null | undefined): string {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return `${origin}${url.startsWith("/") ? "" : "/"}${url}`;
  }

  return { getAbsoluteUrl };
}
